var map = {
	"./module/auth/auth.module": [
		"./src/app/module/auth/auth.module.ts"
	],
	"./module/dashboard/dashboard.module": [
		"./src/app/module/dashboard/dashboard.module.ts",
		"module-dashboard-dashboard-module"
	],
	"./module/static/static.module": [
		"./src/app/module/static/static.module.ts",
		"module-static-static-module"
	],
	"./module/terms/terms.module": [
		"./src/app/module/terms/terms.module.ts"
	]
};
function webpackAsyncContext(req) {
	var ids = map[req];
	if(!ids) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		var id = ids[0];
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "./src/$$_lazy_route_resource lazy recursive";
module.exports = webpackAsyncContext;